import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Edit from "core/ReusableIcons/Edit";
import CircleButton from "core/CircleButton";

import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";

import { generateGridItems } from "./helpers";

const FortButton = styled(CircleButton)`
    position: absolute;
    left: ${convertPxToRem(8)};
    top: ${convertPxToRem(8)};
`;

const ThumbnailContainer = styled.div`
    width: 100%;
    height: ${({ thumbnailHeight }) => convertPxToRem(thumbnailHeight)};
    background-color: ${colors.primary.snow};
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        height: ${convertPxToRem(160)};
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: ${convertPxToRem(18)};
    row-gap: ${convertPxToRem(18)};
    transform: rotate(-45deg);
`;

const Thumbnail = ({
    iconTitleAndThumbnailList = [],
    thumbnailHeight = 0,
    collectionId = "",
    showCollectionFortLink = false
}) => {
    return (
        <ThumbnailContainer thumbnailHeight={thumbnailHeight}>
            <Grid>{generateGridItems(iconTitleAndThumbnailList)}</Grid>
            {showCollectionFortLink && (
                <FortButton
                    icon={<Edit size="sm" />}
                    styleType="cta"
                    size="sm"
                    href={`/fort/collections/${collectionId}/`}
                    target="_blank"
                />
            )}
        </ThumbnailContainer>
    );
};

Thumbnail.propTypes = {
    iconTitleAndThumbnailList: PropTypes.arrayOf(PropTypes.object.isRequired)
        .isRequired,
    thumbnailHeight: PropTypes.number.isRequired,
    collectionId: PropTypes.string.isRequired,
    showCollectionFortLink: PropTypes.bool
};

export default Thumbnail;
